import { shallowMount } from "@vue/test-utils";
import ArrowLeft from "@/components/core/ArrowLeft";

describe("ArrowLeft component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ArrowLeft);
  });

  it("Renders del component ArrowLeft", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
